/**
 * bf2-contact-prefill
 *
 * Förifyller Shopifys kontaktformulär (bf2-rd-contact) från query-parametrar:
 *
 *   /pages/kontakta-oss?amne=Offertförfrågan&meddelande=<text>
 *
 * Textilstudion länkar hit när en möbel saknar tygåtgång och paketpriset därför
 * inte går att räkna ut. Kunden ska slippa skriva om vilken möbel och vilket tyg
 * det gällde. Liquid kan inte läsa query-parametrar, därför görs det här.
 *
 * Self-guardar: gör ingenting utan parametrar eller utan formulär på sidan, och
 * skriver aldrig över ett fält som redan har innehåll (t.ex. återfyllt av
 * Shopify efter ett misslyckat försök).
 */
import { createDebugger } from '~/scripts/utils/debug.js';

const debug = createDebugger('bf2-contact-prefill', false);

function selectSubject(select, wanted) {
    const target = wanted.trim().toLowerCase();
    const match = Array.from(select.options).find((o) => o.value.trim().toLowerCase() === target);
    if (!match) {
        debug.warn('Ämnet finns inte i listan', wanted);
        return false;
    }
    select.value = match.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
}

function prefill() {
    let params;
    try {
        params = new URLSearchParams(window.location.search);
    } catch (e) {
        debug.error('Kunde inte läsa query-parametrar', e);
        return;
    }

    const subject = params.get('amne');
    const message = params.get('meddelande');
    if (!subject && !message) return;

    const body = document.querySelector('textarea[name="contact[body]"]');
    if (!body) {
        debug.log('Inget kontaktformulär på sidan');
        return;
    }
    const form = body.closest('form');

    if (message && !body.value.trim()) {
        body.value = message;
        body.dispatchEvent(new Event('input', { bubbles: true }));
    }

    if (subject && form) {
        const select = form.querySelector('select[name="contact[subject]"]');
        if (select) selectSubject(select, subject);
    }

    // Formuläret ligger under en intro-sektion, så utan detta landar kunden
    // ovanför det ifyllda meddelandet och tror att länken inte gjorde något.
    if (form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const email = form.querySelector('input[name="contact[email]"]');
        if (email && !email.value.trim()) email.focus({ preventScroll: true });
    }

    debug.log('Förifyllde kontaktformuläret', { subject, hasMessage: !!message });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefill, { once: true });
} else {
    prefill();
}
